import React from 'react';
import PropTypes from 'prop-types';

const DepositIframe = ({ url }) => (
  <div className="popup-main-content deposit-iframe-content">
    <iframe
      src={url}
      width={744}
      height={680}
    />
  </div>
);

DepositIframe.propTypes = {
  url: PropTypes.string.isRequired,
};

export default DepositIframe;